import { DS_BADGE_STATE } from "../types/state";
import { DS_BADGE_POSITION } from "../types/position";

export const DS_BADGE_CLASSES = {
  Wrapper: "ds-badge__wrapper",
  WrapperInline: "ds-badge__wrapper--inline",
  WrapperTopRight: "ds-badge__wrapper--top-right",
  WrapperBottomRight: "ds-badge__wrapper--bottom-right",
  Root: "ds-badge",
  StateDefault: "ds-badge--default",
  StateInfo: "ds-badge--info",
  StateSuccess: "ds-badge--success",
  StateDanger: "ds-badge--danger",
  StateNeutral: "ds-badge--neutral",
  StateAccent: "ds-badge--accent",
  Icon: "ds-badge__icon",
  Text: "ds-badge__text",
} as const;

export const DS_BADGE_STATE_TO_CLASS_MAP = {
  [DS_BADGE_STATE.Default]: DS_BADGE_CLASSES.StateDefault,
  [DS_BADGE_STATE.Info]: DS_BADGE_CLASSES.StateInfo,
  [DS_BADGE_STATE.Success]: DS_BADGE_CLASSES.StateSuccess,
  [DS_BADGE_STATE.Danger]: DS_BADGE_CLASSES.StateDanger,
  [DS_BADGE_STATE.Neutral]: DS_BADGE_CLASSES.StateNeutral,
  [DS_BADGE_STATE.Accent]: DS_BADGE_CLASSES.StateAccent,
} as const;

export const DS_BADGE_POSITION_TO_CLASS_MAP = {
  [DS_BADGE_POSITION.Inline]: DS_BADGE_CLASSES.WrapperInline,
  [DS_BADGE_POSITION.TopRight]: DS_BADGE_CLASSES.WrapperTopRight,
  [DS_BADGE_POSITION.BottomRight]: DS_BADGE_CLASSES.WrapperBottomRight,
} as const;
